// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Tips from './Tips';

import '../../styles/modal.css';
import '../../styles/tips.css';

export default class UnclassifiedTips extends Tips {

    renderContent = () => {
        return (<div className="modal-content modal-center">
            {this.state.stage === 0 ? <>
                <h1>Uh Oh! Looks like files couldn't be sorted</h1>
                If you ever find any documents in here, it's because the <strong>AI</strong> bots couldn't sort them. This is usually because <i>they've never seen a document like this</i>, or you <i>don't have enough example documents</i> in the right stack.
                <br /><br />
                <img
                    style={{ width: 400 }}
                    src="https://static.stax.ai/images/graphics/guide-unclassified.png"
                    alt="Moving unclassified documents"
                /><br /><br />
                If an unclassified document belongs in an existing stack, <strong>start dragging the document</strong>. You'll see a list of your stacks to drop the document into, else create a new stack for it!<br /><br />
                When the bots retrain, they'll get better and sort similar documents in the future!
                <br />
                <div className="welcome-next" onClick={this.props.close}>Got it!</div>
            </> : ""}
        </div>);
    }

};